<template>
  <div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{ $t("host") }}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control is-expanded has-icons-left">
            <input
              type="text"
              class="input"
              v-model="meta.host"
              :placeholder="$t('host')"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-server"></i>
            </span>
          </p>
        </div>
        <div class="field">
          <p class="control has-icons-left">
            <input
              type="text"
              class="input"
              v-model="meta.port"
              :placeholder="$t('port')"
            />

            <span class="icon is-small is-left">
              <i class="fa fa-server"></i>
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{ $t("host") }}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_secure"
            v-model="meta.secure"
          />
          <label for="chk_secure">{{ $t("secure") }}</label>
        </div>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_gmail"
            v-model="meta.gmail"
          />
          <label for="chk_gmail">{{ $t("gmail") }}</label>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{ $t("authentication") }}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control is-expanded has-icons-left">
            <input
              type="text"
              class="input"
              v-model="meta.auth.user"
              :placeholder="$t('user')"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-user"></i>
            </span>
          </p>
        </div>
        <div class="field">
          <p class="control has-icons-left">
            <input
              type="text"
              class="input"
              v-model="meta.auth.pass"
              :placeholder="$t('password')"
            />

            <span class="icon is-small is-left">
              <i class="fa fa-lock"></i>
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      meta: {
        host: "",
        port: "",
        secure: false,
        gmail: false,
        auth: {
          user: "",
          pass: "",
        },
      },
    };
  },
  methods: {
    get_data() {
      return this.meta;
    },
    set_data(data) {
      // console.log("data", data);
      this.meta = data;
    },
    clear() {
      this.meta = {
        host: "",
        port: "",
        secure: false,
        gmail: false,
        auth: {
          user: "",
          pass: "",
        },
      };
    },
  },
};
</script>
